import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import WarningDialog from './plugins/warning-dialog/warning-dialog';
import ConfirmDialog from './plugins/confirm-dialog/confirm-dialog';

// css
import './scss/app.scss';

Vue.config.productionTip = false;

const mixin = {
  filters: {
    startCase(str) {
      return _.startCase(str);
    },
    dateAtTime(iso) {
      return iso ? moment
        .utc(iso)
        .format('M/D/YYYY [at] h:mm A') : 'N/A';
    },
    date(iso) {
      return iso ? moment
        .utc(iso)
        .format('M/D/YYYY') : 'N/A';
    },
    time(iso) {
      return moment
        .utc(iso)
        .format('h:mm A');
    },
  },
  methods: {
    goToContentList() {
      this.$router.push({ name: 'Content', params: { section: this.$store.state.selectedContentFilter } });
    },
    goToBlogList() {
      this.$router.push({ name: 'Blog' });
    },
  },
};

Vue.use(WarningDialog);
Vue.use(ConfirmDialog);
Vue.mixin(mixin);

const app = new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');

store.$app = app;
